export default "__VITE_ASSET__C_Mym$uL__"